import { render, staticRenderFns } from "./channelMessage.vue?vue&type=template&id=0f1d1c1c&"
import script from "./channelMessage.vue?vue&type=script&lang=js&"
export * from "./channelMessage.vue?vue&type=script&lang=js&"
import style0 from "./channelMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports